import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { RootState } from '../../../store';
import {
    updateSelect,
    postLineToGetRelatedItems,
} from '../../../store/order/order-actions';
/*models*/
import { IRelatedItems } from '../../../models/order';
import { IOrderDetails } from '../../../models/order';
import { IOptions } from '../../inputs/select-input';
import './order-details-styles.css';

import { ISession } from '../../../models/pro-sites';
import { hasFeature } from '../../authorization/features';
import * as FC from '../../../models/feature-constants';
import * as CON from '../../common/constants';

interface IOrderActionDropdownProps {
    order: IOrderDetails;
    picked: boolean;
    stockOrder: boolean;
    relatedItems: IRelatedItems | null;
    select: number;
    updateSelect: (select: number) => { type: string };
    postLineToGetRelatedItems: (parts: string[]) => Promise<void>;
    session: ISession | null;
}

export const OrderActionDropdown = ({
    order,
    picked,
    stockOrder,
    relatedItems,
    select,
    updateSelect,
    session,
    postLineToGetRelatedItems,
}: IOrderActionDropdownProps) => {
    const intl = useIntl();

    const [noDelete, setNoDelete] = useState(false);
    const [noAdd, setNoAdd] = useState(false);
    /*shipping methods */
    /*initial dropdown options, subject to change based on:
    -status of line items
    -if an order has 'related items' (additems)
    -if an order has any line items that are 'cancel eligible' (deleteItems)
    -if an order has already been cancelled or escalated
    */
    const [options, setOptions] = useState<IOptions[]>([
        {
            value: 1,
            text: intl.formatMessage({
                id: FC.CHANGE_SHIPPING_METHOD_ID,
                defaultMessage: FC.CHANGE_SHIPPING_METHOD,
            }),
            optionalParam: FC.CHANGE_SHIPPING_METHOD,
            disabled: false,
        },
        {
            value: 2,
            text: intl.formatMessage({
                id: FC.CHANGE_SHIPPING_ADDRESS_ID,
                defaultMessage: FC.CHANGE_SHIPPING_ADDRESS,
            }),
            optionalParam: FC.CHANGE_SHIPPING_ADDRESS,
            disabled: false,
        },
        /* {
             value: 3,
             text: 'Change Billing Address',
             disabled: false
         },
         */

        {
            value: 4,
            text: intl.formatMessage({
                id: FC.ADD_ITEMS_TO_ORDER_ID,
                defaultMessage: FC.ADD_ITEMS_TO_ORDER,
            }),
            optionalParam: FC.ADD_ITEMS_TO_ORDER,
            disabled: false,
        },
        {
            value: 5,
            text: intl.formatMessage({
                id: FC.DELETE_ITEMS_FROM_ORDER_ID,
                defaultMessage: FC.DELETE_ITEMS_FROM_ORDER,
            }),
            optionalParam: FC.DELETE_ITEMS_FROM_ORDER,
            disabled: false,
        },

        {
            value: 6,
            text: intl.formatMessage({
                id: FC.BUY_ITEMS_AGAIN_ID,
                defaultMessage: FC.BUY_ITEMS_AGAIN,
            }),
            optionalParam: FC.BUY_ITEMS_AGAIN,
            disabled: false,
        },

        {
            value: 7,
            text: intl.formatMessage({
                id: FC.CANCEL_ORDER_ID,
                defaultMessage: FC.CANCEL_ORDER,
            }),
            optionalParam: FC.CANCEL_ORDER,
            disabled: false,
        },
    ]);
    let partNumber: string;
    const parts: string[] = [];

    useEffect(() => {
        order.lineItems.forEach((lineItem) => {
            if (lineItem.shippableFlag === 'Y') {
                partNumber = lineItem.partNumber;
                parts.push(partNumber);
                return parts;
            }
        });

        if (
            order.lineItems.every((x) => x.cancelEligible === 'N') ||
            order.orderType === CON.REPAIR_REMAKE_LD ||
            order.isCustom === true ||
            (order.lineItems.some((x) =>
                x.description.includes('Absolute Power')
            ) &&
                order.lineItems.some((x) => x.description.includes('RIC')))
        ) {
            setNoDelete(true);
        }
        if (!relatedItems && hasFeature(session!, FC.ADD_ITEMS_TO_ORDER)) {
            postLineToGetRelatedItems(parts);
        }
        if (
            (relatedItems && relatedItems.relatedItems.length === 0) ||
            order.cqOrderStatus === CON.ORDER_STATUS_TESTING ||
            order.cqOrderStatus === CON.ORDER_STATUS_SHIPPED ||
            (relatedItems &&
                relatedItems.relatedItems.length !== 0 &&
                order.orderType === CON.REPAIR_REMAKE_LD) ||
            (order.cartItems.some(
                (cartItem) => cartItem.typeId === CON.CartItemTypes.RicWithAp
            ) &&
                order.lineItems.some(
                    (lineItem) =>
                        lineItem.productOptions &&
                        lineItem.productOptions.some(
                            (productOption) =>
                                productOption.id === CON.CROS_SYSTEM_OPTIONS_ID
                        )
                ))
        ) {
            setNoAdd(true);
        }

        switch (session!.country) {
            case CON.US:
                /*series of setting dropdown options based on above logic */

                if (noAdd && noDelete && !stockOrder) {
                    setOptions([
                        {
                            value: 1,
                            text: intl.formatMessage({
                                id: FC.CHANGE_SHIPPING_METHOD_ID,
                                defaultMessage: FC.CHANGE_SHIPPING_METHOD,
                            }),
                            optionalParam: FC.CHANGE_SHIPPING_METHOD,
                            disabled: false,
                        },
                        {
                            value: 2,
                            text: intl.formatMessage({
                                id: FC.CHANGE_SHIPPING_ADDRESS_ID,
                                defaultMessage: FC.CHANGE_SHIPPING_ADDRESS,
                            }),
                            optionalParam: FC.CHANGE_SHIPPING_ADDRESS,
                            disabled: false,
                        },
                        /* {
                     value: 3,
                     text: 'Change Billing Address',
                     disabled: false
                 },
                 */

                        {
                            value: 7,
                            text: intl.formatMessage({
                                id: FC.CANCEL_ORDER_ID,
                                defaultMessage: FC.CANCEL_ORDER,
                            }),
                            optionalParam: FC.CANCEL_ORDER,
                            disabled: false,
                        },
                    ]);
                } else if (noAdd && !noDelete && !stockOrder) {
                    setOptions([
                        {
                            value: 1,
                            text: intl.formatMessage({
                                id: FC.CHANGE_SHIPPING_METHOD_ID,
                                defaultMessage: FC.CHANGE_SHIPPING_METHOD,
                            }),
                            optionalParam: FC.CHANGE_SHIPPING_METHOD,
                            disabled: false,
                        },
                        {
                            value: 2,
                            text: intl.formatMessage({
                                id: FC.CHANGE_SHIPPING_ADDRESS_ID,
                                defaultMessage: FC.CHANGE_SHIPPING_ADDRESS,
                            }),
                            optionalParam: FC.CHANGE_SHIPPING_ADDRESS,
                            disabled: false,
                        },

                        {
                            value: 5,
                            text: intl.formatMessage({
                                id: FC.DELETE_ITEMS_FROM_ORDER_ID,
                                defaultMessage: FC.DELETE_ITEMS_FROM_ORDER,
                            }),
                            optionalParam: FC.DELETE_ITEMS_FROM_ORDER,
                            disabled: false,
                        },

                        {
                            value: 7,
                            text: intl.formatMessage({
                                id: FC.CANCEL_ORDER_ID,
                                defaultMessage: FC.CANCEL_ORDER,
                            }),
                            optionalParam: FC.CANCEL_ORDER,
                            disabled: false,
                        },
                    ]);
                } else if (!noAdd && !noDelete && !stockOrder) {
                    setOptions([
                        {
                            value: 1,
                            text: intl.formatMessage({
                                id: FC.CHANGE_SHIPPING_METHOD_ID,
                                defaultMessage: FC.CHANGE_SHIPPING_METHOD,
                            }),
                            optionalParam: FC.CHANGE_SHIPPING_METHOD,
                            disabled: false,
                        },
                        {
                            value: 2,
                            text: intl.formatMessage({
                                id: FC.CHANGE_SHIPPING_ADDRESS_ID,
                                defaultMessage: FC.CHANGE_SHIPPING_ADDRESS,
                            }),
                            optionalParam: FC.CHANGE_SHIPPING_ADDRESS,
                            disabled: false,
                        },
                        /* {
                     value: 3,
                     text: 'Change Billing Address',
                     disabled: false
                 },
                 */

                        {
                            value: 4,
                            text: intl.formatMessage({
                                id: FC.ADD_ITEMS_TO_ORDER_ID,
                                defaultMessage: FC.ADD_ITEMS_TO_ORDER,
                            }),
                            optionalParam: FC.ADD_ITEMS_TO_ORDER,
                            disabled: false,
                        },
                        {
                            value: 5,
                            text: intl.formatMessage({
                                id: FC.DELETE_ITEMS_FROM_ORDER_ID,
                                defaultMessage: FC.DELETE_ITEMS_FROM_ORDER,
                            }),
                            optionalParam: FC.DELETE_ITEMS_FROM_ORDER,
                            disabled: false,
                        },

                        {
                            value: 7,
                            text: intl.formatMessage({
                                id: FC.CANCEL_ORDER_ID,
                                defaultMessage: FC.CANCEL_ORDER,
                            }),
                            optionalParam: FC.CANCEL_ORDER,
                            disabled: false,
                        },
                    ]);
                } else if (noAdd && noDelete && stockOrder) {
                    setOptions([
                        {
                            value: 1,
                            text: intl.formatMessage({
                                id: FC.CHANGE_SHIPPING_METHOD_ID,
                                defaultMessage: FC.CHANGE_SHIPPING_METHOD,
                            }),
                            optionalParam: FC.CHANGE_SHIPPING_METHOD,
                            disabled: false,
                        },
                        {
                            value: 2,
                            text: intl.formatMessage({
                                id: FC.CHANGE_SHIPPING_ADDRESS_ID,
                                defaultMessage: FC.CHANGE_SHIPPING_ADDRESS,
                            }),
                            optionalParam: FC.CHANGE_SHIPPING_ADDRESS,
                            disabled: false,
                        },
                        /*
                {
                    value: 3,
                    text: 'Change Billing Address',
                    disabled: false
                },
                */
                        {
                            value: 6,
                            text: intl.formatMessage({
                                id: FC.BUY_ITEMS_AGAIN_ID,
                                defaultMessage: FC.BUY_ITEMS_AGAIN,
                            }),
                            optionalParam: FC.BUY_ITEMS_AGAIN,
                            disabled: false,
                        },

                        {
                            value: 7,
                            text: intl.formatMessage({
                                id: FC.CANCEL_ORDER_ID,
                                defaultMessage: FC.CANCEL_ORDER,
                            }),
                            optionalParam: FC.CANCEL_ORDER,
                            disabled: false,
                        },
                    ]);
                } else if (!noAdd && noDelete && !stockOrder) {
                    setOptions([
                        {
                            value: 1,
                            text: intl.formatMessage({
                                id: FC.CHANGE_SHIPPING_METHOD_ID,
                                defaultMessage: FC.CHANGE_SHIPPING_METHOD,
                            }),
                            optionalParam: FC.CHANGE_SHIPPING_METHOD,
                            disabled: false,
                        },
                        {
                            value: 2,
                            text: intl.formatMessage({
                                id: FC.CHANGE_SHIPPING_ADDRESS_ID,
                                defaultMessage: FC.CHANGE_SHIPPING_ADDRESS,
                            }),
                            optionalParam: FC.CHANGE_SHIPPING_ADDRESS,
                            disabled: false,
                        },
                        /* {
                     value: 3,
                     text: 'Change Billing Address',
                     disabled: false
                 },
                 */

                        {
                            value: 4,
                            text: intl.formatMessage({
                                id: FC.ADD_ITEMS_TO_ORDER_ID,
                                defaultMessage: FC.ADD_ITEMS_TO_ORDER,
                            }),
                            optionalParam: FC.ADD_ITEMS_TO_ORDER,
                            disabled: false,
                        },

                        {
                            value: 7,
                            text: intl.formatMessage({
                                id: FC.CANCEL_ORDER_ID,
                                defaultMessage: FC.CANCEL_ORDER,
                            }),
                            optionalParam: FC.CANCEL_ORDER,
                            disabled: false,
                        },
                    ]);
                } else if (noAdd && !noDelete && stockOrder) {
                    setOptions([
                        {
                            value: 1,
                            text: intl.formatMessage({
                                id: FC.CHANGE_SHIPPING_METHOD_ID,
                                defaultMessage: FC.CHANGE_SHIPPING_METHOD,
                            }),
                            optionalParam: FC.CHANGE_SHIPPING_METHOD,
                            disabled: false,
                        },
                        {
                            value: 2,
                            text: intl.formatMessage({
                                id: FC.CHANGE_SHIPPING_ADDRESS_ID,
                                defaultMessage: FC.CHANGE_SHIPPING_ADDRESS,
                            }),
                            optionalParam: FC.CHANGE_SHIPPING_ADDRESS,
                            disabled: false,
                        },

                        {
                            value: 5,
                            text: intl.formatMessage({
                                id: FC.DELETE_ITEMS_FROM_ORDER_ID,
                                defaultMessage: FC.DELETE_ITEMS_FROM_ORDER,
                            }),
                            optionalParam: FC.DELETE_ITEMS_FROM_ORDER,
                            disabled: false,
                        },

                        {
                            value: 6,
                            text: intl.formatMessage({
                                id: FC.BUY_ITEMS_AGAIN_ID,
                                defaultMessage: FC.BUY_ITEMS_AGAIN,
                            }),
                            optionalParam: FC.BUY_ITEMS_AGAIN,
                            disabled: false,
                        },

                        {
                            value: 7,
                            text: intl.formatMessage({
                                id: FC.CANCEL_ORDER_ID,
                                defaultMessage: FC.CANCEL_ORDER,
                            }),
                            optionalParam: FC.CANCEL_ORDER,
                            disabled: false,
                        },
                    ]);
                } else if (!noAdd && noDelete && stockOrder) {
                    setOptions([
                        {
                            value: 1,
                            text: intl.formatMessage({
                                id: FC.CHANGE_SHIPPING_METHOD_ID,
                                defaultMessage: FC.CHANGE_SHIPPING_METHOD,
                            }),
                            optionalParam: FC.CHANGE_SHIPPING_METHOD,
                            disabled: false,
                        },
                        {
                            value: 2,
                            text: intl.formatMessage({
                                id: FC.CHANGE_SHIPPING_ADDRESS_ID,
                                defaultMessage: FC.CHANGE_SHIPPING_ADDRESS,
                            }),
                            optionalParam: FC.CHANGE_SHIPPING_ADDRESS,
                            disabled: false,
                        },
                        /* {
                     value: 3,
                     text: 'Change Billing Address',
                     disabled: false
                 },
                 */

                        {
                            value: 4,
                            text: intl.formatMessage({
                                id: FC.ADD_ITEMS_TO_ORDER_ID,
                                defaultMessage: FC.ADD_ITEMS_TO_ORDER,
                            }),
                            optionalParam: FC.ADD_ITEMS_TO_ORDER,
                            disabled: false,
                        },

                        {
                            value: 6,
                            text: intl.formatMessage({
                                id: FC.BUY_ITEMS_AGAIN_ID,
                                defaultMessage: FC.BUY_ITEMS_AGAIN,
                            }),
                            optionalParam: FC.BUY_ITEMS_AGAIN,
                            disabled: false,
                        },

                        {
                            value: 7,
                            text: intl.formatMessage({
                                id: FC.CANCEL_ORDER_ID,
                                defaultMessage: FC.CANCEL_ORDER,
                            }),
                            optionalParam: FC.CANCEL_ORDER,
                            disabled: false,
                        },
                    ]);
                } else if (!noAdd && !noDelete && stockOrder) {
                    setOptions([
                        {
                            value: 1,
                            text: intl.formatMessage({
                                id: FC.CHANGE_SHIPPING_METHOD_ID,
                                defaultMessage: FC.CHANGE_SHIPPING_METHOD,
                            }),
                            optionalParam: FC.CHANGE_SHIPPING_METHOD,
                            disabled: false,
                        },
                        {
                            value: 2,
                            text: intl.formatMessage({
                                id: FC.CHANGE_SHIPPING_ADDRESS_ID,
                                defaultMessage: FC.CHANGE_SHIPPING_ADDRESS,
                            }),
                            optionalParam: FC.CHANGE_SHIPPING_ADDRESS,
                            disabled: false,
                        },
                        /* {
                     value: 3,
                     text: 'Change Billing Address',
                     disabled: false
                 },
                 */ {
                            value: 5,
                            text: intl.formatMessage({
                                id: FC.DELETE_ITEMS_FROM_ORDER_ID,
                                defaultMessage: FC.DELETE_ITEMS_FROM_ORDER,
                            }),
                            optionalParam: FC.DELETE_ITEMS_FROM_ORDER,
                            disabled: false,
                        },
                        {
                            value: 4,
                            text: intl.formatMessage({
                                id: FC.ADD_ITEMS_TO_ORDER_ID,
                                defaultMessage: FC.ADD_ITEMS_TO_ORDER,
                            }),
                            optionalParam: FC.ADD_ITEMS_TO_ORDER,
                            disabled: false,
                        },

                        {
                            value: 6,
                            text: intl.formatMessage({
                                id: FC.BUY_ITEMS_AGAIN_ID,
                                defaultMessage: FC.BUY_ITEMS_AGAIN,
                            }),
                            optionalParam: FC.BUY_ITEMS_AGAIN,
                            disabled: false,
                        },

                        {
                            value: 7,
                            text: intl.formatMessage({
                                id: FC.CANCEL_ORDER_ID,
                                defaultMessage: FC.CANCEL_ORDER,
                            }),
                            optionalParam: FC.CANCEL_ORDER,
                            disabled: false,
                        },
                    ]);
                }
                break;
            case CON.FR:
                //change shipping address and cancel order
                //are the only options at this moment for 'FR'
                if (order.isCancelEligible) {
                    setOptions([
                        {
                            value: 2,
                            text: intl.formatMessage({
                                id: FC.CHANGE_SHIPPING_ADDRESS_ID,
                                defaultMessage: FC.CHANGE_SHIPPING_ADDRESS,
                            }),
                            optionalParam: FC.CHANGE_SHIPPING_ADDRESS,
                            disabled: false,
                        },
                        {
                            value: 7,
                            text: intl.formatMessage({
                                id: FC.CANCEL_ORDER_ID,
                                defaultMessage: FC.CANCEL_ORDER,
                            }),
                            optionalParam: FC.CANCEL_ORDER,
                            disabled: false,
                        },
                    ]);
                } else {
                    //set only change shipping address
                    setOptions([
                        {
                            value: 2,
                            text: intl.formatMessage({
                                id: FC.CHANGE_SHIPPING_ADDRESS_ID,
                                defaultMessage: FC.CHANGE_SHIPPING_ADDRESS,
                            }),
                            optionalParam: FC.CHANGE_SHIPPING_ADDRESS,
                            disabled: false,
                        },
                    ]);
                }
                break;
            case CON.CA:
                //Canada should have: cancel order, escalate order, buy items again at this moment
                //Canada should NOT have: change shipping ADDRESS, change shipping METHOD,
                //add items, delete items
                if (order.isCancelEligible) {
                    setOptions([
                        {
                            value: 6,
                            text: intl.formatMessage({
                                id: FC.BUY_ITEMS_AGAIN_ID,
                                defaultMessage: FC.BUY_ITEMS_AGAIN,
                            }),
                            optionalParam: FC.BUY_ITEMS_AGAIN,
                            disabled: false,
                        },
                        {
                            value: 7,
                            text: intl.formatMessage({
                                id: FC.CANCEL_ORDER_ID,
                                defaultMessage: FC.CANCEL_ORDER,
                            }),
                            optionalParam: FC.CANCEL_ORDER,
                            disabled: false,
                        },
                    ]);
                } else {
                    setOptions([
                        {
                            value: 6,
                            text: intl.formatMessage({
                                id: FC.BUY_ITEMS_AGAIN_ID,
                                defaultMessage: FC.BUY_ITEMS_AGAIN,
                            }),
                            optionalParam: FC.BUY_ITEMS_AGAIN,
                            disabled: false,
                        },
                    ]);
                }
                break;
            default:
                break;
        }
    }, [order, picked, relatedItems, noAdd, noDelete]);

    return (
        <>
            <div className="row" style={{ paddingTop: '20px' }}>
                <div className="col-md-12">
                    <label className="control-label">
                        <strong>
                            <FormattedMessage
                                id={CON.NEED_CHANGES_IN_ORDER_ID}
                                defaultMessage={
                                    CON.NEED_TO_MAKE_CHANGES_TO_ORDER
                                }
                            />
                        </strong>
                    </label>
                    <div className="tooltipCancel">
                        <span
                            className="fas fa-info-circle"
                            aria-hidden="true"
                        ></span>
                        <span className="tooltiptext">
                            <FormattedMessage
                                id={CON.ORDER_DETAILS_TOOLTIP_ID}
                                defaultMessage={CON.ORDER_DETAILS_TOOLTIP}
                            />
                        </span>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-md-12">
                    <select
                        value={select}
                        className="form-control"
                        onChange={(e) => {
                            const choice: number = parseInt(e.target.value);
                            updateSelect(choice);
                        }}
                    >
                        <option value={0}>
                            {intl.formatMessage({
                                id: CON.SELECT_ITEM_ID,
                                defaultMessage: CON.SELECT_ITEM,
                            })}
                        </option>

                        {options.map(
                            (option) =>
                                hasFeature(session!, option.optionalParam!) && (
                                    <option
                                        key={option.value}
                                        value={option.value}
                                    >
                                        {option.text}
                                    </option>
                                )
                        )}
                    </select>
                </div>
            </div>
        </>
    );
};
const mapStateToProps = (state: RootState) => {
    return {
        select: state.select,
        relatedItems: state.relatedItems ? state.relatedItems.data! : null,
        session: state.session ? state.session.data! : null,
    };
};

const mapDispatchToProps = {
    updateSelect,
    postLineToGetRelatedItems,
};

const orderActionDropdownContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(OrderActionDropdown);
export default orderActionDropdownContainer;
